<template>
    <div class="cu-modal bottom-modal payed-dialog"
         :class="(hasDisplayDesc)?'show':''">
        <div class="cu-dialog">
            <div class="close" @click="hide"></div>
            <div class="icon"></div>
            <div class="view flex align-center justify-start flex-direction">
                <div style="margin-top: 50px;" class="text-20 text-500 text-black">支付成功</div>
                <div class="margin-top-sm text-df text-gray" v-if="desc">{{desc}}</div>
                <div class="margin-top-sm text-df text-gray" v-else="">你已成功升级{{upinfo}}</div>
                <div class="button" @click="trigger('reFlush')">返回</div>
                <div style="margin-top: 139px;" class="text-blue text-df" @click="trigger('services')">开具发票   I  联系客服</div>
            </div>
        </div>
    </div>
</template>
<script>
  import App from '../util/comfun'
  export default {
    props:{

    },
    data () {
      return {
        hasDisplayDesc:false,
        upinfo:'',
        desc:'',
      }
    },
    components:{
    },
    methods:{
        show(params){
        this.hasDisplayDesc=true
          this.upinfo=params.upinfo
          this.desc=params.desc
        },
      hide(){
        this.hasDisplayDesc=false
        this.upinfo=''
      },
      trigger(act){
        this.$emit('event',{act:act});
        this.hide()
      },
    },
    created(){

    },
  }
</script>
<style scoped>
    .payed-dialog .cu-dialog{
        width: 375px;
        height: 410px;
        background: #F6F6F6;
        border-radius: 8px 8px 0 0;
        overflow: visible;
    }
    .payed-dialog .close{
        position: absolute;
        right:15px;
        top:20px;
        background-image: url("https://assets.pfotoo.com/images/version/a9222631e6d96a459e3cd2d00551fe56.png");
        width: 20px;
        height: 20px;
        background-size: 100% 100%;
    }
    .payed-dialog .icon{
        width: 60px;
        height: 60px;
        background-image: linear-gradient(1deg, #E09D59 0%, #F1DAB9 100%);
        border-radius: 50%;
        position: absolute;
        top:-30px;
        left:calc(50% - 30px);
        background-image: url("https://assets.pfotoo.com/images/version/payed.png");
        background-size: 100% 100%;
    }
    .payed-dialog .button{
        width: 150px;
        height: 40px;
        background-image: linear-gradient(180deg, #E9C46A 0%, #F4A261 100%);
        border-radius: 20px;
        margin-top: 85px;
        line-height: 40px;

        font-family: PingFangSC-Medium;
        font-weight: 500;
        font-size: 14px;
        color: #FFFFFF;
    }
</style>


// WEBPACK FOOTER //
// src/components/payed-dialog.vue